var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a", [
    _c("span", [_vm._v("Unable to submit some events. Please check for")]),
    _c("br"),
    _vm._v(" "),
    _c(
      "ul",
      _vm._l(_vm.messages, function(message) {
        return _c("li", { staticClass: "modal-body-text" }, [
          _vm._v(_vm._s(message))
        ])
      })
    ),
    _vm._v(" "),
    _c("span", { staticClass: "modal-body-text" }, [
      _vm._v("All completed events have been submitted.")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-77914b57", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77914b57","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/ModalBodyWithErrorCodes.vue
// module id = 1410
// module chunks = 1